/**
 * Auto-generated custom permissions from @requireExplicitWritePermission tags.
 */

export enum CustomPermissions {
  ManageTaggedPresets = "custom:ManageTaggedPresets",
  UpdateProtectedUserFields = "custom:UpdateProtectedUserFields",
}
